import { isGettedTaskIllustrationIdDTO } from "../DTO/ServerResponseType/Task/TaskIllustration";
import { ServerClient, serverOrigin } from "./Configs";
import TaskServerClient from "./TaskServerClient";
import { getTypeGuardedVariableAsync } from "./typeGuard";

class TaskIllustrationServerClient {
  path = TaskServerClient.path + "/illustration";

  async sendToConnectIllustrationToTaskAsync(
    taskId: string,
    illustrationId: string
  ): Promise<string | never> {
    let url: string = serverOrigin + this.path + "/connect";

    let taskIllustrationId = await getTypeGuardedVariableAsync(
      ServerClient.sendRequestAsync({
        url: url,
        method: "POST",
        body: JSON.stringify({
          taskId: taskId,
          illustrationId: illustrationId,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      }),
      isGettedTaskIllustrationIdDTO
    )
      .then((taskIllustrationIdDTO) => {
        alert("Иллюстрация успешно добавлена в задачу");
        return taskIllustrationIdDTO.taskIllustrationId;
      })
      .catch((error) => {
        console.error("Ошибка:", error);
        throw error;
      });

    return taskIllustrationId;
  }

  async sendToDisconnectIllustrationFromTaskAsync(
    taskIllustrationId: string
  ): Promise<unknown> {
    let url: string = serverOrigin + this.path + "/disconnect";

    let sendPromise = ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({ taskIllustrationId: taskIllustrationId }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    return sendPromise.catch((error) => {
      console.error("Ошибка:", error);
    });
  }
}

let taskIllustrationServerClient = new TaskIllustrationServerClient();

export default taskIllustrationServerClient;
